import { PlusOutlined, RightOutlined } from "@ant-design/icons";
import React from "react";
import { Link } from "react-router-dom";
import product from "../../assets/product.png";
import heart from "../../assets/heart.png";
import { Rate } from "antd";
import { useTranslation } from "react-i18next";

const LatestOffers = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div className="py-14">
      <div>
        <h3 className="text-[#14294F] text-2xl font-semibold text-center">
          {t("Our Latest Offers")}
        </h3>
        <p className="text-[#737E91] text-lg mt-4 w-5/6 text-center mx-auto">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit
        </p>
      </div>

      {/* one  */}
      <div className="mt-14">
        <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-4 lg:items-center w-2/3 mx-auto">
          <div className="flex">
            <div className="relative">
              <img
                src={product}
                className="rounded-3xl w-[350px] h-[280px] mx-auto"
              />
              <div className="bg-[#FCFBFA] w-[50px] h-[50px] mx-auto flex items-center rounded-full absolute top-5 right-5">
                <img src={heart} className="text-[#fe6625] mx-auto w-[22px]" />
              </div>
              <div className="bg-[#fb7c3eb3] text-white border border-white rounded-lg py-2 px-3 absolute -top-4 -left-10">
                10% OFF
              </div>
            </div>
          </div>
          <div>
            <h3 className="text-[#283D63] text-2xl font-semibold">Cage Lamp</h3>
            <Rate disabled defaultValue={5} className="mt-3 custom-rate" />
            <p className="text-[#737E91] text-lg mt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit.
            </p>
            <div className="mt-4 flex items-center">
              <button className="bg-[#19161B] border-2 border-[#FE6625] w-[45px] h-[35px] rounded-lg mr-3"></button>
              <button className="bg-[#ECEBEC] w-[45px] h-[35px] rounded-lg mr-3"></button>
              <button className="bg-[#94BEEF] w-[45px] h-[35px] rounded-lg mr-3"></button>
              <button className="bg-[#153C6A] w-[45px] h-[35px] rounded-lg mr-3"></button>
            </div>
            <div className="lg:flex items-center justify-between px-3 mt-4">
              <div>
                <p className="text-[#606D84] font-semibold text-xl">1546 SR</p>
              </div>
              <button className="bg-[#FE9B71] text-white flex items-center px-5 py-2 text-xl rounded-full font-semibold max-lg:mt-4">
                Add <PlusOutlined className="ml-4" />
              </button>
              <div>
                <Link
                  to="/"
                  className="text-[#FE9B71] rounded-full border-2 border-[#FE9B71] px-5 py-2 text-xl flex items-center justify-center font-semibold max-lg:mt-4"
                >
                  View details
                  <RightOutlined className="ml-3 font-bold" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* two  */}
      <div className="mt-14">
        <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-4 lg:items-center w-2/3 mx-auto max-lg:flex max-lg:flex-wrap-reverse">
          <div>
            <h3 className="text-[#283D63] text-2xl font-semibold">Cage Lamp</h3>
            <Rate disabled defaultValue={5} className="mt-3 custom-rate" />
            <p className="text-[#737E91] text-lg mt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud. Lorem ipsum dolor sit amet,
              consectetur adipiscing elit.
            </p>
            <div className="mt-4 flex items-center">
              <button className="bg-[#19161B] border-2 border-[#FE6625] w-[45px] h-[35px] rounded-lg mr-3"></button>
              <button className="bg-[#ECEBEC] w-[45px] h-[35px] rounded-lg mr-3"></button>
              <button className="bg-[#94BEEF] w-[45px] h-[35px] rounded-lg mr-3"></button>
              <button className="bg-[#153C6A] w-[45px] h-[35px] rounded-lg mr-3"></button>
            </div>
            <div className="lg:flex items-center justify-between px-3 mt-4">
              <div>
                <p className="text-[#606D84] font-semibold text-xl">1546 SR</p>
              </div>
              <button className="bg-[#FE9B71] text-white flex items-center px-5 py-2 text-xl rounded-full font-semibold max-lg:mt-4">
                Add <PlusOutlined className="ml-4" />
              </button>
              <div>
                <Link
                  to="/"
                  className="text-[#FE9B71] rounded-full border-2 border-[#FE9B71] px-5 py-2 text-xl flex items-center justify-center font-semibold max-lg:mt-4"
                >
                  View details
                  <RightOutlined className="ml-3 font-bold" />
                </Link>
              </div>
            </div>
          </div>

          <div className="flex justify-end">
            <div className="relative">
              <img
                src={product}
                className="rounded-3xl w-[350px] h-[280px] mx-auto"
              />
              <div className="bg-[#FCFBFA] w-[50px] h-[50px] mx-auto flex items-center rounded-full absolute top-5 left-5">
                <img src={heart} className="text-[#fe6625] mx-auto w-[22px]" />
              </div>
              <div className="bg-[#fb7c3eb3] text-white border border-white rounded-lg py-2 px-3 absolute -top-4 -right-10">
                30% OFF
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestOffers;
